import { Component } from "@angular/core";
import { BaseInputComponent } from "../shared";

@Component({
  selector: 'multi-choice-group',
  templateUrl: './multiChoiceGroupComponent.html'
})
export class MultiChoiceGroupComponent extends BaseInputComponent  {
  
} 